import React from 'react';
import '../Offerings/DeleteConfirmationModal.css';

export default function ConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?", 
  confirmText = "Confirm", 
  cancelText = "Cancel", 
  isDanger = false,
  isLoading = false 
}) {
  if (!isOpen) return null;

  const handleConfirmClick = async () => {
    try {
      await onConfirm();
    } catch (err) {
      console.error("Confirmation error:", err);
    }
  };

  const handleCloseClick = () => {
    if (isLoading) return;
    onClose();
  };

  return (
    <div className="off-modal-overlay">
      <div className="off-modal-content">
        <h2 className="off-modal-title">{title}</h2>
        <p className="off-modal-body">{message}</p>
        <div className="off-modal-actions">
          <button 
            type="button"
            className="off-modal-btn off-modal-btn--ghost" 
            onClick={handleCloseClick}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button 
            type="button"
            className="off-modal-btn"
            onClick={handleConfirmClick}
            disabled={isLoading}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              justifyContent: 'center',
              backgroundColor: isDanger ? '#b32b2b' : '#3bb3ae',
              color: isDanger ? '#ffffff' : '#071414',
              border: 'none'
            }}
          >
            {isLoading ? (
              <>
                <span className="off-modal-spinner"></span>
                Processing...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
